import React from "react";

export default function LowerRoundHeader({
	x,
	y = 0,
	width,
	roundHeader,
	canvasPadding,
	numOfRounds,
	columnIndex,
	upperBracketHeight,
	onClick,
	customHeaderText,
	isQualifierRound,
}) {
	customHeaderText = customHeaderText ? customHeaderText : null;
	return (
		// @ts-ignore
		<g style={{ pointerEvents: "bounding-box" }} onClick={onClick}>
			<rect
				x={x}
				y={y + canvasPadding + upperBracketHeight}
				width={width}
				height={roundHeader.height}
				fill={roundHeader.backgroundColor}
				rx="3"
				ry="3"
			/>
			<text
				fontFamily={roundHeader.fontFamily}
				x={x + width / 2}
				y={y + canvasPadding + upperBracketHeight + roundHeader.height / 2}
				style={{
					fontSize: `${roundHeader.fontSize}px`,
					color: roundHeader.fontColor,
					userSelect: "none",
					WebkitUserSelect: "none",
				}}
				fill="currentColor"
				dominantBaseline="middle"
				textAnchor="middle"
			>
				{customHeaderText ??
					GetLowerBracketHeaderName(
						columnIndex,
						isQualifierRound ? numOfRounds - 1 : numOfRounds
					)}
			</text>
		</g>
	);
}

export function GetLowerBracketHeaderName(
	columnIndex: number,
	numOfRounds: number
) {
	if (columnIndex + 1 === numOfRounds) {
		return "Lower Final";
	} else if (columnIndex + 1 === numOfRounds - 1) {
		return "Lower Semi-Finals";
	} else if (columnIndex + 1 === numOfRounds - 2) {
		return "Lower Quarter-Finals";
	} else if (columnIndex + 1 < numOfRounds - 2) {
		return `Lower Round ${columnIndex + 1}`;
	}
}
